import { render } from "./PortalHelp.vue?vue&type=template&id=55c74398&scoped=true"
import script from "./PortalHelp.vue?vue&type=script&lang=js"
export * from "./PortalHelp.vue?vue&type=script&lang=js"

import "./PortalHelp.vue?vue&type=style&index=0&id=55c74398&scoped=true&lang=css"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-55c74398"]])

export default __exports__